import { fade, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(
  (theme) => {
    return {
      headerBtn: {
        padding: "2px",
        margin: "0 15px",
      },
      searchListPopper: {
        zIndex: 9,
      },
      searchWrapper: {
        boxShadow:
          "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
        borderRadius: 4,
        maxHeight: "80vh",
        background: "#fff",
        width: 300,
      },
      popoverList: {
        cursor: "pointer",
        maxWidth: 300,
        padding: "0 16px",
        "& li": {
          padding: 4,
          "& .avatar-img": {
            width: 32,
            height: 32,
            margin: 0,
          },
        },
      },
      notifTitle: {
        borderBottom: "solid 1px #c5c4c4",
        padding: "10px 8px",
      },
      search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        "&:hover": {
          backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("xs")]: {
          marginLeft: theme.spacing(1),
          width: "auto",
        },
        [theme.breakpoints.down("xs")]: {
          position: "fixed",
          top: 10,
          right: 45,
          background: "#fff",

          "&:hover": {
            background: "#fff",
          },
        },
      },
      searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      targetImg: {
        minWidth: 50,
        width: 50,
        height: 31,
        display: "block",
        objectFit: "cover",
        borderRadius: 4,
        marginRight: 12,
      },
      userImgWrapper: {
        minWidth: 50,
        width: 50,
        height: 30,
        marginRight: 12,
        "& .pending-icon": {
          left: -2,
          bottom: -2,
          width: 12,
          height: 12,
        },
      },
      checkinImgWrapper: {
        minWidth: 50,
        width: 50,
        height: 30,
        display: "block",
        borderRadius: 4,
        marginRight: 12,
        background: "#F5F5F5",
        textAlign: "center",
        padding: 4,
      },
      checkinImg: {
        height: 22,
      },
      inputRoot: (props) => {
        const iconColor =
          props.appTheme === "CLASSIC"
            ? "#777"
            : props.appTheme === "LIGHT"
            ? "#a5a5a5"
            : "#B8D0EC";
        return {
          color: "inherit",
          [theme.breakpoints.down("xs")]: {
            position: "fixed",
            right: 42,
            background: "#fff",
          },
          "& svg": {
            position: "absolute",
            right: 12,
            zIndex: -1,
            fontSize: 25,
            color: iconColor,
            cursor: "pointer",
          },
          "& input": {
            cursor: "pointer",
          },
          "&.Mui-focused": {
            "& input": {
              cursor: "inherit",
            },
          },
        };
      },
      inputInput: {
        fontSize: 14,
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("xs")]: {
          width: "0",
          padding: "6px 32px 6px 6px",
          zIndex: "1",
          "&:focus": {
            width: "22ch",
            borderBottom: "solid 1px #D5DAEC",
            [theme.breakpoints.down("xs")]: {
              width: "62vw",
            },
          },
        },
        [theme.breakpoints.down("sm")]: {
          marginRight: 0,
        },
        "&.expandInput": {
          width: "22ch",
          transition: theme.transitions.create("width"),
          borderBottom: "solid 1px #D5DAEC",
        },
      },
      searchbarLoader: {
        position: "absolute",
        right: 3,
        "& .MuiCircularProgress-root": {
          height: "30px !important",
          width: "30px !important",
          animation: "none",
          marginTop: 12,
        },
      },
      closeBtn: {
        marginTop: "-12px",
        zIndex: "2",
        cursor: "pointer",
      },
    };
  },
  { index: 1 }
);
